import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function Icon({ icon, className, ...props }) {
    return <FontAwesomeIcon icon={icon} className={className + ' mr-2'} {...props} />;
}
